import { Component, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MagliveApiClient } from 'src/lib/api-client/maglive-api-client';
import { PointHistory, PointHistoriesGetRequest } from 'src/lib/entity/manage-point';
import { POINT_FLUCT_KIND_LIST } from 'src/lib/constants'
import { ToastrService } from 'ngx-toastr';
import * as encoding from 'encoding-japanese'
import { saveAs } from 'file-saver'

@Component({
  selector: 'maglive-admin-point-history-index',
  templateUrl: './point-history-index.component.html',
  styleUrls: [
    '../../../../pages/admin/startbootstrap-sb-admin-gh-pages/src/scss/styles.scss',
    './point-history-index.component.scss',
  ],
})
export class AdminPointHistoryIndexComponent {
  // ポイント変動種別の定数
  pointFluctKindList = POINT_FLUCT_KIND_LIST

  // 検索パラメータ
  search = {
    id: null,
    userId: null,
    createdAtStart: null,
    createdAtEnd: null,
    pointHistoryKind: null,
  }

  pointHistories: PointHistory[] = []

  /**
   * 無限スクロール対象要素の親クラス名
   * https://www.npmjs.com/package/ngx-infinite-scroll fromRoot
   */
  infiniteScrollParentSelector = '.admin-point-history-scroll-wrap'

  // 無限スクロールでデータを取りきったかどうかのフラグ
  private allRead: Boolean = false
  // データ取得中かどうかのフラグ
  isLoading: Boolean = false

  invalidCsvDl: Boolean;
  csvDateValidationError: Boolean = false
  dateRequiredError: Boolean = false

  // 無限スクロールの起点となるドキュメントID
  private lastDocumentId: string | null = null

  constructor(
    public changeDetectorRef: ChangeDetectorRef,
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.search.id = this.route.snapshot.queryParamMap.get('id') || null
    this.search.userId = this.route.snapshot.queryParamMap.get('userId') || null
    this.search.pointHistoryKind = Number(this.route.snapshot.queryParamMap.get('pointHistoryKind')) || null
    this.search.createdAtStart = this.route.snapshot.queryParamMap.get('createdAtStart') || null
    this.search.createdAtEnd = this.route.snapshot.queryParamMap.get('createdAtEnd') || null
    const request: PointHistoriesGetRequest = {
      ...this.search,
      createdAtStart: this.search.createdAtStart ? Date.parse(this.search.createdAtStart) / 1000 : null,
      createdAtEnd: this.search.createdAtEnd ? Date.parse(this.search.createdAtEnd) / 1000 : null,
      lastDocumentId: null,
    }
    this.isLoading = true
    this.getPointHistories(request)
  }

  /**
   * 検索条件に基づいたポイント履歴一覧を取得する
   */
  execSearch(): void {
    this.lastDocumentId = null
    const request: PointHistoriesGetRequest = {
      ...this.search,
      createdAtStart: this.search.createdAtStart ? Date.parse(this.search.createdAtStart) / 1000 : null,
      createdAtEnd: this.search.createdAtEnd ? Date.parse(this.search.createdAtEnd) / 1000 : null,
      lastDocumentId: null,
    }
    this.allRead = false
    this.isLoading = true
    this.getPointHistories(request)
    // 強制的に再描画させる
    this.changeDetectorRef.detectChanges()
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        ...this.search,
      },
    })
  }

  /**
   * スクロールイベントをトリガーする
   */
  onScroll() {
    if (this.allRead || this.isLoading) return
    const request: PointHistoriesGetRequest = {
      ...this.search,
      createdAtStart: this.search.createdAtStart ? Date.parse(this.search.createdAtStart) / 1000 : null,
      createdAtEnd: this.search.createdAtEnd ? Date.parse(this.search.createdAtEnd) / 1000 : null,
      lastDocumentId: this.lastDocumentId,
    }
    this.isLoading = true
    this.getPointHistoriesByScroll(request)
    // 強制的に再描画させる
    this.changeDetectorRef.detectChanges()
  }

  /**
   * ポイント履歴を取得する
   */
  private getPointHistories(request: PointHistoriesGetRequest): void {
    MagliveApiClient.getPointHistories(request).subscribe((response) => {
      if (response !== 'NOT_FOUND') {
        this.pointHistories = response.items
        this.lastDocumentId = response.lastDocumentId
      } else {
        this.pointHistories = []
      }
      this.isLoading = false
    })
  }

  /**
   * スクロール時にポイント履歴を取得する
   */
  private getPointHistoriesByScroll(request: PointHistoriesGetRequest): void {
    MagliveApiClient.getPointHistories(request).subscribe((response) => {
      if (response !== 'NOT_FOUND' && response.items.length > 0) {
        if (this.pointHistories.length !== 0) {
          this.pointHistories = this.pointHistories.concat(response.items)
        } else {
          this.pointHistories = response.items
        }
        this.lastDocumentId = response.lastDocumentId
      } else {
        this.allRead = true
      }
      this.isLoading = false
    })
  }

  exportPointHistories() {
    if (!this.search.createdAtEnd || !this.search.createdAtStart) {
      this.dateRequiredError = true
      return
    } else this.dateRequiredError = false
    this.lastDocumentId = null
    //日付の差が 1 か月以上あるかどうかを検証
    var months
    const start = new Date(this.search.createdAtStart)
    const end = new Date(this.search.createdAtEnd)
    months = (start.getFullYear() - end.getFullYear()) * 12
    months -= start.getMonth()
    months += end.getMonth()
    if (start.getDate() > end.getDate()) months--
    months <= 0
      ? (this.csvDateValidationError = false)
      : (this.csvDateValidationError = true)

    const request: PointHistoriesGetRequest = {
      ...this.search,
      createdAtStart: this.search.createdAtStart
        ? Date.parse(this.search.createdAtStart) / 1000
        : null,
      createdAtEnd: this.search.createdAtEnd
        ? Date.parse(this.search.createdAtEnd) / 1000
        : null,
      lastDocumentId: null,
    }
    if (!this.csvDateValidationError) this.getCsvData(request)
  }

  getCsvData(request: PointHistoriesGetRequest) {
    this.invalidCsvDl = true
    MagliveApiClient.exportPointHistories(request).subscribe(
      (value) => {
        if (value === 'NOT_FOUND') {
          this.invalidCsvDl = false
          this.toastr.error('エラーが発生しました。')
          return
        }

        if(value === 'VALIDATION_ERROR') {
          this.invalidCsvDl = false
          this.toastr.error('出力条件が正しくありません。')
          return
        }
        
        if (!value.fileData.length) {
          this.invalidCsvDl = false
          this.toastr.error('ポイント動向履歴データが存在していません。')
          return
        }

        const fileName = value.fileName
        const fileData = value.fileData

        const unicodeList = []
        for (let i = 0; i < fileData.length; i++) {
          unicodeList.push(fileData.charCodeAt(i))
        }

        const shiftJisCodeList = encoding.convert(
          unicodeList,
          'SJIS',
          'UNICODE'
        )
        const unit8Array = new Uint8Array(shiftJisCodeList)

        const blob = new Blob([unit8Array], { type: 'text/csv' })

        saveAs(blob, fileName)
        this.invalidCsvDl = false
      },
      (error) => {
        this.invalidCsvDl = false
        console.log(error)
      }
    )
  }
}
